export default __webpack_public_path__ + "static/media/persent-icon.0d96d2e0.svg";